<template>
  <div class="pr_page">
    <div class="list_wrapper">
      <div class="list">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ2OAQ9FiatF32GekIchznLvMW4c1IsofwyzvdqQRsTwrVNiaFV1InYPsaSEowYaI5xuPECSPcDf3FA/0" class="user_pic" />
        <strong class="user_name">只为今生</strong>
      </div>
      <div class="list">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ2OAQ9FiatF32GekIchznLvMW4c1IsofwyzvdqQRsTwrVNiaFV1InYPsaSEowYaI5xuPECSPcDf3FA/0" class="user_pic" />
        <strong class="user_name">只为今生</strong>
      </div>
      <div class="list">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ2OAQ9FiatF32GekIchznLvMW4c1IsofwyzvdqQRsTwrVNiaFV1InYPsaSEowYaI5xuPECSPcDf3FA/0" class="user_pic" />
        <strong class="user_name">只为今生</strong>
      </div>
      <div class="list">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ2OAQ9FiatF32GekIchznLvMW4c1IsofwyzvdqQRsTwrVNiaFV1InYPsaSEowYaI5xuPECSPcDf3FA/0" class="user_pic" />
        <strong class="user_name">只为今生</strong>
      </div>
      <div class="list">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ2OAQ9FiatF32GekIchznLvMW4c1IsofwyzvdqQRsTwrVNiaFV1InYPsaSEowYaI5xuPECSPcDf3FA/0" class="user_pic" />
        <strong class="user_name">只为今生</strong>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name:"myPromters"
}
</script>

<style lang="stylus">
.pr_page
  padding-bottom:60px
  background:#fff
  .list
    padding:20px 30px
    border-bottom:1px solid #f0f0f0
    /*px*/
    display:flex
    background:#fff
    .user_pic
      flex:0 0 40px
      width:40px
      height:40px
      border-radius:50%
    .user_name
      font-size:30px
      color:#999
      flex:1
      text-align:center
      line-height:40px
</style>



// WEBPACK FOOTER //
// src/components/userCenter/myPromoters.vue